import { render, staticRenderFns } from "./RoomDescriptionItem.vue?vue&type=template&id=018a4154&scoped=true&"
import script from "./RoomDescriptionItem.vue?vue&type=script&lang=ts&"
export * from "./RoomDescriptionItem.vue?vue&type=script&lang=ts&"
import style0 from "./RoomDescriptionItem.vue?vue&type=style&index=0&id=018a4154&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "018a4154",
  null
  
)

export default component.exports